import { Key } from 'protractor';

export class CONFIGUREPORTALREQUEST {
    screenId: number;
    updatedBy: string;
    activityCode: string;
    portletId: number;
    [Key: string]: any;
}
